import { render } from "./ManageAgreements.vue?vue&type=template&id=608d1651&scoped=true&ts=true"
import script from "./ManageAgreements.vue?vue&type=script&lang=ts"
export * from "./ManageAgreements.vue?vue&type=script&lang=ts"

import "./ManageAgreements.vue?vue&type=style&index=0&id=608d1651&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-608d1651"]])

export default __exports__